import { render, staticRenderFns } from "./abonements.vue?vue&type=template&id=5a397418&scoped=true&"
import script from "./abonements.vue?vue&type=script&lang=js&"
export * from "./abonements.vue?vue&type=script&lang=js&"
import style0 from "./abonements.vue?vue&type=style&index=0&id=5a397418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a397418",
  null
  
)

export default component.exports